module.exports = __webpack_public_path__ + "img/person.ea535cdd.png";